import { apiService } from './api';
import { User, RegisterRequest } from '../types';

export const userService = {
  async registerUser(data: RegisterRequest): Promise<User> {
    const response = await apiService.post<User>('/users/register', data);
    return response.data;
  },

  async getActiveUsers(organizationCode?: string): Promise<User[]> {
    const response = await apiService.get<User[]>('/users?org='+organizationCode);
    return response.data;
  },

  async deactivateUser(userId: string): Promise<User> {
    const response = await apiService.patch<User>(`/users/${userId}/deactivate`);
    return response.data;
  },

  async activateUser(userId: string): Promise<User> {
    const response = await apiService.patch<User>(`/users/${userId}/activate`);
    return response.data;
  },

  async deleteUser(userId: string): Promise<User> {
    const response = await apiService.delete<User>(`/users/${userId}/delete-user`);
    return response.data;
  }
};
